import { formatNumberWithComma } from '@/utils/stringUtils';

const formatDateSimple = (timestamp, m, d, h, mm) => {
  const date = new Date(timestamp);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${month}${m} ${day}${d} ${hours}${h} ${minutes}${mm}`;
};

const timeAgo = (timestamp, d, h, mm, s, ago, justago) => {
  const now = new Date();
  const then = new Date(timestamp);

  const diff = Math.floor((now - then) / 1000); // 차이를 초 단위로 계산

  const days = Math.floor(diff / (60 * 60 * 24));
  const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((diff % (60 * 60)) / 60);
  const seconds = diff % 60;

  // 결과 문자열에 0인 값은 제외
  const parts = [];
  if (days > 0) parts.push(`${days}${d}`);
  if (hours > 0) parts.push(`${hours}${h}`);
  if (minutes > 0) parts.push(`${minutes}${mm}`);
  if (seconds > 0) parts.push(`${seconds}${s}`);

  // parts 배열을 공백으로 join
  return parts.length > 0 ? parts.join(' ') + ` ${ago}` : justago;
};

const formatOnlyDate = (timestamp, y, m, d, inf) => {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1 필요
  const day = String(date.getDate()).padStart(2, '0');
  if (`${year}-${month}-${day}` === '2999-12-31') {
    return inf;
  }
  return `${year}${y} ${month}${m} ${day}${d}`;
};

// YYYY-MM-DD 형식으로 날짜를 반환하는 함수
const dateFormatKebab = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const dateFormatDot = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}`;
};

const formatDateDotMonthDay = (date) => {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${month}.${day}`;
};

const dateFormateKebabTimestamp = (date) => {
  const dateKebab = dateFormatKebab(date);
  const dateBase = new Date(date);
  const timeHour = String(dateBase.getHours()).padStart(2, 0);
  const timeMinute = String(dateBase.getMinutes()).padStart(2, 0);
  return `${dateKebab} ${timeHour}:${timeMinute}`;
};

const formatSimpleTimeAgo = (timestamp) => {
  const now = new Date();
  const then = new Date(timestamp);
  const diff = Math.floor((now - then) / 1000);

  const MINUTE = 60;
  const HOUR = MINUTE * 60;
  const DAY = HOUR * 24;

  if (diff < 60) return [formatNumberWithComma(diff), 'label_sec_short'];
  if (diff < 60 * 60) return [formatNumberWithComma(Math.floor(diff / MINUTE)), 'label_minute'];
  if (diff < 60 * 60 * 24) return [formatNumberWithComma(Math.floor(diff / HOUR)), 'label_hour'];
  return [formatNumberWithComma(Math.floor(diff / DAY)), 'label_day'];
};

export {
  formatOnlyDate,
  timeAgo,
  formatDateSimple,
  dateFormatKebab,
  dateFormatDot,
  formatDateDotMonthDay,
  dateFormateKebabTimestamp,
  formatSimpleTimeAgo,
};
